export const removeStartAndEndWhiteSpaces = (value: string) => {
  return value.trim();
};

export const isMobileDevice = () => {
  return (
    typeof window.orientation !== 'undefined' ||
    navigator.userAgent.indexOf('IEMobile') !== -1
  );
};

export const isIOSDevice = () => {
  try {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
  } catch {
    return false;
  }
}

export function getBasePath(): string {
  // In development or when not in main-test production, use root path
  const environment = import.meta.env.VITE_ENVIRONMENT ?? 'dev';
  
  const raw =
    import.meta.env.VITE_BASE_PATH ??
    (environment === 'main-test' ? '/vb/' : '/');

  const withLeading = raw.startsWith('/') ? raw : `/${raw}`;

  const withoutTrailing = withLeading.replace(/\/+$/, '');

  return withoutTrailing === '/' ? '' : withoutTrailing;

}
